"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldTreeView = void 0;
var core_api_1 = require("@ikegps/core-api");
var icon_1 = require("../../../components/icon");
var icons_1 = require("../../../components/icon/icons");
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var form_palette_1 = require("../form.palette");
var form_field_tree_view_style_1 = require("./form.field.tree.view.style");
(0, theme_1.addStyles)(form_field_tree_view_style_1.Style);
var FormFieldTreeView = /** @class */ (function () {
    function FormFieldTreeView() {
    }
    FormFieldTreeView.view = function (editor) {
        var isSelected = editor.designer.selectedFieldId === editor.field.fieldId;
        var className = "".concat(form_field_tree_view_style_1.CSS.container, " ").concat(isSelected ? form_field_tree_view_style_1.CSS.isSelected : '');
        return (0, mithril_1.m)('div', { className: className }, FormFieldTreeView.viewButton(editor));
    };
    FormFieldTreeView.viewForm = function (editor) {
        var children = [];
        for (var _i = 0, _a = editor.field.fields; _i < _a.length; _i++) {
            var field = _a[_i];
            children.push(editor.designer.viewField(field));
        }
        children.push(FormFieldTreeView.viewButtonNew(editor));
        return (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.form.container }, [
            FormFieldTreeView.view(editor),
            (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.form.children }, children)
        ]);
    };
    FormFieldTreeView.viewButton = function (editor) {
        var isCloneable = editor.field.isCloneable;
        var isTitle = editor.field.title;
        var isLocked = editor.isLocked;
        var isSubtitle = editor.field.subtitle;
        var isHidden = editor.field.collector === core_api_1.IkeCollectorType.OFFICE;
        var isAdminOnly = editor.field.adminOnly;
        var isStatus = editor.field.isStatusField;
        var isRequired = editor.field.required;
        var isMapColor = editor.field.isMapColorField;
        var tags = null;
        if (isCloneable || isTitle || isLocked || isSubtitle || isHidden || isAdminOnly || isRequired || isStatus || isMapColor) {
            tags = (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.tag.list }, [
                isTitle ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_LABEL)
                }, 'L') : null,
                isSubtitle ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_SECONDARY_LABEL)
                }, 'SL') : null,
                isCloneable ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.cloneable,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_CLONEABLE)
                }, 'C') : null,
                isHidden ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_HIDE)
                }, 'H') : null,
                isAdminOnly ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_ADMIN_ONLY)
                }, 'A') : null,
                isStatus ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.status,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_STATUS)
                }, 'ST') : null,
                isMapColor ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.status,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_MAP_COLOR)
                }, 'M') : null,
                isLocked ? icon_1.Icon.view(icons_1.MaterialIcon.LOCK, {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.cloneable,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_LOCKED)
                }) : null,
                isRequired ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_REQUIRED)
                }, 'R') : null
            ]);
        }
        var text = editor.field.displayName;
        if (text == null || text.trim().length === 0) {
            text = (0, i18n_1.Translate)(i18n_1.T.FIELD_DISPLAY_NAME_MISSING);
        }
        return (0, mithril_1.m)('button', {
            className: "mdl-button ".concat(form_field_tree_view_style_1.CSS.title, " ").concat(editor.state.isValid ? '' : form_field_tree_view_style_1.CSS.isInvalid),
            onclick: function () { return editor.designer.setSelected(editor.field); }
        }, [
            (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.label.container }, [
                form_palette_1.FormDesignerPalette.viewIcon(editor.field.type, { className: form_field_tree_view_style_1.CSS.label.icon }),
                (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.label.text, title: text }, text)
            ]),
            tags
        ]);
    };
    FormFieldTreeView.viewButtonNew = function (editor) {
        var title = (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_ADD, { name: editor.field.displayName });
        return (0, mithril_1.m)('button', { className: "mdl-button ".concat(form_field_tree_view_style_1.CSS.title), onclick: editor.addField }, [
            (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.label.container }, [
                icon_1.Icon.view(icons_1.MaterialIcon.ADD, { className: form_field_tree_view_style_1.CSS.label.icon }),
                (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.label.text, title: title }, title)
            ])
        ]);
    };
    return FormFieldTreeView;
}());
exports.FormFieldTreeView = FormFieldTreeView;
//# sourceMappingURL=form.field.tree.view.js.map